import { useEffect, useState } from "react";
import { OrderContent } from "../../components/order/OrderList";
import PointsDeleteMissionModal from "../modal/points/PointsDeleteMissionModal";
import PointsUpdateMissionModal from "../modal/points/PointsUpdateMissionModal";
import PointsMissionsMenu from "./PointsMissionsMenu";

function PointMissionsList({ orders, ogData, callback, loading, onDelete }) {
  if (loading)
    return (
      <div className="flex w-full items-center justify-center my-4">
        <div className="primaryLoader"></div>
      </div>
    );
  // console.log(object)

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex flex-col mt-4 bg-[#F0F6FC] gap-2 p-1 rounded-md">
        {orders?.map((order, index) => (
          <Order
            key={index}
            order={order}
            og={ogData?.at(index)}
            callback={callback}
            onDelete={onDelete}
          />
        ))}
      </div>
    </div>
  );
}

export default PointMissionsList;

const Order = ({ order, og, callback, onDelete }) => {
  // const navigate = useNavigate()
  // const location = useLocation()
  const [open, setOpen] = useState(false);
  const [expand, setExpand] = useState(false);
  const [menuLoading, setMenuLoading] = useState(false);
  const [modal, setModal] = useState({
    edit: false,
    delete: false,
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open) {
        setTimeout(() => {
          setOpen(false);
        }, 400);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="w-full flex  justify-between bg-white p-2 lg:p-4 gap-3 rounded-md">
      <PointsUpdateMissionModal
        open={modal.edit}
        setOpen={(val) => setModal({ ...modal, edit: val })}
        mission={og}
        callback={callback}
      />
      <PointsDeleteMissionModal
        open={modal.delete}
        setOpen={(val) => setModal({ ...modal, delete: val })}
        mission={og}
        callback={onDelete}
      />
      <div className="flex flex-col md:flex-row justify-between flex-1">
        {order?.map(({ elements, width }, index) => (
          <div
            className={`w-full rounded-lg ${width || "flex-1"} ${
              !expand && index !== 0 ? "hidden md:flex" : "flex"
            } flex-col ${
              expand && "border-b pb-3"
            } mb-2 px-2 md:border-b-0 md:pb-0`}
            key={index}
          >
            {elements?.map((element, idx) => (
              <OrderContent element={element} key={idx} order={og} />
            ))}
          </div>
        ))}
      </div>
      <div
        className={`${
          //   bookingData?.status || og?.status ? "flex" : "hidden"
          ""
        } flex flex-col justify-between items-center `}
      >
        <button
          className="cursor-pointer p-2 relative "
          disabled={menuLoading}
          onClick={() => setOpen(true)}
        >
          {menuLoading ? (
            <div className="primaryLoader"></div>
          ) : (
            <img
              src="/IconMore.svg"
              alt=""
              className="h-5 object-contain relative"
            />
          )}
          {open && (
            <PointsMissionsMenu
              onDelete={() => setModal({ ...modal, delete: true })}
              onEdit={() => setModal({ ...modal, edit: true })}
            />
          )}
          {/* <SM className="">
          </SM> */}
        </button>
        <button
          className="flex lg:hidden"
          onClick={() => {
            setExpand(!expand);
          }}
        >
          <img
            src="/IconChevronDown.svg"
            alt=""
            className={`w-5 object-contain transition-all ${
              expand ? "rotate-180" : ""
            }`}
          />
        </button>
      </div>
    </div>
  );
};
